// The one place the admin mints a course's shareable link. The grammar is
// the steering page's (edxr-marketing src/lib/edxr-link.ts, buildWrapperUrl)
// and the viewers' (com.edxr.deeplink LinkGrammar, EdxrLinkBootstrap):
//
//   https://educationxr.com/open/content/<nodeID>[?install=auto][&launch=auto]
//
// The wrapper URL, never a raw edxr:// string: recipients without the app
// land on the /open/ page (store steering), recipients with it get the
// course. The parameters always come in this order: install, launch.
//
// A link never names an organization (owner, 2026-10-13 and 2026-10-20): the
// server works out the course's organization (content's launch-check), and the
// bridge and viewers still accept an old link's ?org= but ignore it.
//
// install=auto installs the course, or updates it when it is out of date.
// launch=auto launches it, but only once it is installed (the viewer waits on
// its content-installed gate), so a link that launches always installs too:
// without install=auto a course that isn't installed would wait forever.

export const WRAPPER_ORIGIN = 'https://educationxr.com'

export const courseLink = (nodeID, { install, launch } = {}) => {
  const params = []
  if (install || launch) params.push('install=auto')
  if (launch) params.push('launch=auto')

  return `${WRAPPER_ORIGIN}/open/content/${nodeID}${params.length ? `?${params.join('&')}` : ''}`
}
